// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--2oS8q";
export var jump = "heading-module--jump--3Q0RH";